{
	"error": {
		"message": "An error occurred while processing your request. Please try again."
	},
	"placeholder": "Type your message...",
	"initialMessage": "Hello, how can I help you?"
}
